"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const styled_components_1 = __importDefault(require("styled-components"));
const Counter = styled_components_1.default.span.attrs({
    className: `counter`,
})(({ theme }) => theme.counter);
exports.default = Counter;
//# sourceMappingURL=Counter.js.map